import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { styled } from "./styled";
export const TableContainer = styled("div", ({ $theme, $cols, $gridTemplateColumns }) => ({
    color: $theme.foreground,
    display: "grid",
    gridTemplateColumns: $gridTemplateColumns ?? `repeat(${$cols}, auto)`,
    rowGap: 1,
    background: $theme.background3,
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: $theme.background3,
    borderRadius: 10,
    overflow: "hidden",
}));
export const TableCell = styled("div", ({ $theme, $header }) => ({
    background: $theme.background1,
    height: 40,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    paddingLeft: 10,
    paddingRight: 10,
    gap: 10,
    cursor: "pointer",
    ...($header
        ? {
            position: "sticky",
            top: 0,
            fontWeight: "bold",
        }
        : {}),
}));
export const EditableTableCell = styled("input", ({ $theme, $header }) => ({
    background: $theme.background1,
    height: 40,
    border: "none",
    outline: "none",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 10,
    paddingRight: 10,
    gap: 10,
    ...($header
        ? {
            position: "sticky",
            top: 0,
            fontWeight: "bold",
        }
        : {}),
}));
export const TableRow = styled("div", {
    display: "contents",
});
/**
 * Usage:
 * ```tsx
    <Table header={["Subject", "Status", "Customer"]}>
      {conversationsQuery.data.conversations.map((conversation) => (
        <TableRow
          key={conversation.uuid}
          onClick={() => {
            navigate(`conversation/${conversation.uuid}`);
          }}
        >
          <TableCell>{conversation.subject}</TableCell>
          <TableCell>{conversation.status}</TableCell>
          <TableCell>{conversation.external.email}</TableCell>
        </TableRow>
      ))}
    </Table>
 * ```
 */
export const Table = React.memo(function Table(props) {
    const cols = props.header.length;
    return (_jsxs(TableContainer, { "$cols": cols, "$gridTemplateColumns": props.$gridTemplateColumns, children: [props.header.map((header) => (_jsx(TableCell, { "$header": true, children: header }))), props.children] }));
});
